<div class="drilldown-chart-container">
  <ng-container *ngIf="!isLoading; else skeletonLoader">
    <div class="drilldown-chart-container-header" [ngClass]="size">
      <div>{{ title }}</div>
      <div>
        <mat-icon
          svgIcon="info"
          class="drilldown-chart-container-button"
          cdkOverlayOrigin
          #infoOrigin="cdkOverlayOrigin"
          (mouseenter)="infoTooltipOpen = true"
          (mouseleave)="infoTooltipOpen = false"
        ></mat-icon>
        <cds-tooltip
          [origin]="infoOrigin"
          [open]="infoTooltipOpen"
          placement="left"
          [panelWidth]="256"
          [hasBackdrop]="false"
          (hovered)="infoTooltipOpen = true"
          (unhovered)="infoTooltipOpen = false"
        >
          <ng-template #tooltipContent>
            {{ infoText || 'No information available' }}
          </ng-template>
        </cds-tooltip>
        <mat-icon
          *ngIf="size === 'medium'"
          svgIcon="enlarge"
          class="drilldown-chart-container-button"
          (click)="onExpandChartClicked()"
        ></mat-icon>
      </div>
    </div>
    <ng-content select="[chart-element]"></ng-content>
  </ng-container>

  <ng-template #skeletonLoader>
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{ minWidth: getSkeletonLoaderWidth() }"
    />
    <ngx-skeleton-loader
      count="1"
      appearance="line"
      [theme]="{
        minWidth: getSkeletonLoaderWidth(),
        height: getSkeletonLoaderHeight(),
        borderRadius: '5px'
      }"
    >
    </ngx-skeleton-loader>
  </ng-template>
</div>
